<div class="modal-content">
  <!-- Modal Header -->
  <div class="modal-header">
    <div class="header-content">
      <h3 class="modal-title">{{ modalTitle }}</h3>
      <div class="header-icons">
        <i class="fa minimize-icon"
           [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
           (click)="minimise = !minimise"></i>
        <i class="fa fa-times close-icon" (click)="cancel()"></i>
      </div>
    </div>
  </div>

  <!-- Modal Body -->
  <div class="modal-body" [class.collapsed]="minimise">

    <!-- Loading Spinner -->
    @if (dataLoading) {
<div class="loading-container">
      <i class="fa fa-spinner fa-spin loading-icon"></i>
      <div class="loading-text">Loading Schedule I data...</div>
    </div>
}

    @if (!dataLoading) {
<div class="schedule-i-container">
      <div class="instructions">
        <h4>
          <i class="fa fa-info-circle"></i>
          All amounts in U. S. Dollars
        </h4>
      </div>

      <!-- Schedule I Table -->
      <table class="table table-bordered schedule-table">
        <thead>
          <tr>
            <th rowspan="2" class="text-center line-header">5471 Line</th>
            <th rowspan="2" class="text-center description-header">Description</th>
            <th rowspan="2" class="text-center column-header">GHOST Amount</th>
            <th rowspan="2" class="text-center column-header">FIR Override Amount</th>
          </tr>
        </thead>
        <tbody>
          @for (line of irsF5471ScheduleIData; track trackByLineNo($index, line)) {
<tr [ngStyle]="line.backgroudColor">
            <td class="text-center line-number">{{ line.line_no !== 'N/A' ? line.line_no : '' }}</td>
            <td class="line-description">{{ line.line_Description }}</td>
            <td class="text-right column-cell" [ngStyle]="line.GHOST_AMT.column_style">
              @if (line.GHOST_AMT.is_Display) {
<div>{{ (line.GHOST_AMT.VALUE | number) || 0 }}</div>
}
            </td>
            <td class="text-right column-cell" [ngStyle]="line.FIR_OVERRIDE_VALUE.column_style">
              @if (line.FIR_OVERRIDE_VALUE.is_editable && line.FIR_OVERRIDE_VALUE.is_Display) {
<div>
                <input
                  type="text"
                  [(ngModel)]="line.FIR_OVERRIDE_VALUE.VALUE"
                  class="text-right form-control input-sm numText"
                  placeholder="0"
                  (ngModelChange)="onFIROverrideChange()" />
              </div>
}
              @if (!line.FIR_OVERRIDE_VALUE.is_editable && line.FIR_OVERRIDE_VALUE.is_Display) {
<div>
                {{ (line.FIR_OVERRIDE_VALUE.VALUE | number) || 0 }}
              </div>
}
            </td>
          </tr>
}
        </tbody>
      </table>

      <!-- Error Message -->
      @if (userMessage) {
<div class="alert alert-warning">
        {{ userMessage }}
      </div>
}
    </div>
}
  </div>

  <!-- Footer Actions -->
  <div class="modal-footer">
    <button
      class="btn btn-info btn-sm"
      type="button"
      (click)="save()"
      [disabled]="crudLoading">
      @if (crudLoading) {
<span>
        <i class="fa fa-spinner fa-pulse"></i>
      </span>
}
      Save
    </button>
    <button
      class="btn btn-danger-outline btn-sm"
      type="button"
      (click)="restoreGHOSTAmt()">
      Restore GHOST Amount
    </button>
    <button
      class="btn btn-danger-outline btn-sm"
      type="button"
      (click)="reset()">
      Reset
    </button>
    <button
      class="btn btn-warning btn-sm"
      type="button"
      (click)="cancel()">
      Cancel
    </button>
  </div>
</div>
